// msalConfig.jsx
// Microsoft (Azure AD) SSO configuration — the counterpart to the Google
// OAuth client id used in App.js. A single PublicClientApplication instance is
// created here and shared through <MsalProvider> so the whole app talks to the
// same MSAL cache.

import { PublicClientApplication } from "@azure/msal-browser";

// Azure AD app registration for Project360.
//   clientId  = Application (client) id
//   authority = https://login.microsoftonline.com/<tenant id>
export const msalConfig = {
  auth: {
    clientId: "400001b2-4e44-47f9-af30-6200c13fa6e2",
    authority:
      "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    // Popup flow only — never let MSAL take over the main window / route.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // Match the app's existing session storage so sign-in state is cleared
    // when the browser tab closes.
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Scopes requested at sign-in. openid/profile/email give us the ID token the
// backend verifies; User.Read is the default Graph delegated permission.
export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
  // Always show the account picker so a re-login after logout prompts the user
  // instead of silently reusing the cached Microsoft account.
  prompt: "select_account",
};

export const msalInstance = new PublicClientApplication(msalConfig);
